import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function assignLeads(body) {
    try {
        return await axios.post(`${LEADS_ENDPOINT}/assignations`, body)
    } catch {
        throw new Error()
    }
}
